import { useState, useEffect } from "react";
import cls from "classnames";
import styles from "./index.module.scss";
import { EFuntionCall } from "logic/src/objects/session/types";

// import i18next from "logic/src/i18n";
// import { ReactComponent as CompleteIcon } from "@/components/icons/complete.svg";
// import { ReactComponent as PictureIcon } from "./icons/picture.svg";
// import { ReactComponent as CodeIcon } from "./icons/code.svg";
// import { ReactComponent as PaintIcon } from "./icons/paint.svg";
// import { ReactComponent as SearchWebIcon } from "./icons/search_web.svg";
// import { ReactComponent as DocIcon } from "./icons/doc.svg";
// import { ReactComponent as ThinkingIcon } from "./icons/thinking.svg";

// const setMap = {
//   [EFuntionCall.data_analysis]: {
//     icon: CodeIcon,
//     text: i18next.t("sensechat-201"), // 正在编写代码...
//     completeText: i18next.t("sensechat-202"), // 编写完成
//     color: "#F0BC43",
//   },
//   [EFuntionCall.running]: {
//     icon: CodeIcon,
//     text: i18next.t("sensechat-203"), // 正在执行代码...
//     completeText: i18next.t("sensechat-204"), // 编写完成
//     color: "#F0BC43",
//   },
//   [EFuntionCall.text2image]: {
//     icon: PaintIcon,
//     text: i18next.t("sensechat-207"), // 正在绘画中...
//     completeText: i18next.t("sensechat-208"), // 绘画完成
//     color: "#A472F5",
//   },
//   [EFuntionCall.web_search]: {
//     icon: SearchWebIcon,
//     text: i18next.t("sensechat-209"), // 正在搜索网络资料...
//     completeText: i18next.t("sensechat-210"), // 搜索完成
//     color: "#49ACE9",
//   },
//   [EFuntionCall.vqa_agent]: {
//     icon: PictureIcon,
//     text: i18next.t("sensechat-211"), // 正在理解图片...
//     completeText: i18next.t("sensechat-212"), // 调用完成
//     color: "#5D63C5",
//   },
//   [EFuntionCall.thinking]: {
//     icon: ThinkingIcon,
//     text: i18next.t("sensechat-199"), // 正在思考中...
//     completeText: i18next.t("sensechat-200"), // 思考完成
//     color: "#5D63C5",
//   },
//   ["doc_thinking"]: {
//     icon: DocIcon,
//     text: i18next.t("sensechat-213"), // 正在理解文档...
//     completeText: i18next.t("sensechat-217"), // 理解完成
//     color: "#536CEF",
//   },
// };

// type TStatus = "loading" | "completed" | "willCompleted";
// interface IProps {
//   type: EFuntionCall | "doc_thinking";
//   completed: boolean;
//   className?: string;
//   onComplete?: () => void;
// }

// const StatusLoading = ({ type, completed, className, onComplete }: IProps) => {
//   const [status, setStatus] = useState<TStatus>(
//     completed ? "completed" : "loading",
//   );
//   const current = setMap[type];

//   useEffect(() => {
//     if (completed && status === "loading") {
//       setStatus("willCompleted");
//       window.setTimeout(() => {
//         setStatus("completed");
//         onComplete?.();
//       }, 2000);
//     }
//   }, [completed, status]);

//   if (status === "completed") return null;
//   return (
//     <div className={cls(styles.container, className)}>
//       {status === "loading" ? (
//         <current.icon />
//       ) : (
//         <CompleteIcon style={{ color: current.color, fontSize: "24px" }} />
//       )}
//       <span className={styles.text}>
//         {status === "loading" ? current.text : current.completeText}
//       </span>
//     </div>
//   );
// };

interface IProps {
  type: EFuntionCall | "doc_thinking";
  completed: boolean;
  className?: string;
  onComplete?: () => void;
}

type TStatus = "loading" | "completed" | "willCompleted";

const setMap: {
  [pro: string]: {
    text: string;
  };
} = {
  [EFuntionCall.text2image]: {
    text: "再等等呦，看我施展绘画魔法～",
  },
  [EFuntionCall.web_search]: {
    text: "再等等呦，且让我去搜搜网络资料～", // 正在搜索网络资料...
  },
  [EFuntionCall.thinking]: {
    text: "正在思考中...", // 正在思考中...
  },
};

const StatusLoading = ({ type, className, completed, onComplete }: IProps) => {
  const [thinkingTime, setThinkingTime] = useState<number>(1);
  const [status, setStatus] = useState<TStatus>(
    completed ? "completed" : "loading",
  );
  const current = setMap[type];

  useEffect(() => {
    if (completed && status === "loading") {
      setStatus("willCompleted");
      window.setTimeout(() => {
        setStatus("completed");
        onComplete?.();
      }, 1000);
    }
  }, [completed, status]);

  useEffect(() => {
    const timer = setInterval(() => {
      setThinkingTime(prev => prev + 1);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  if (status === "completed") return null;
  return (
    <div className={cls(styles.containerV2, className)}>
      {setMap?.[type].text || "正在思考中..."}（已用时 {thinkingTime} 秒）
    </div>
  );
};

export default StatusLoading;
